import { css } from 'styled-components';
import { BORDER_COLOR, PADDING, ROOT_COLOR, SIZE, TYPE_SPEC, VALUE_COLOR, } from './tokens';
import { CFMixins } from '../../../../mixins';
export const rootBackground = ({ alternateTheme, colorway, strength, }) => alternateTheme
    ? ROOT_COLOR.ALTERNATE[colorway][strength]
    : ROOT_COLOR.DEFAULT[colorway][strength];
export const rootBorder = ({ alternateTheme, colorway, strength, }) => alternateTheme
    ? BORDER_COLOR.ALTERNATE[colorway][strength]
    : BORDER_COLOR.DEFAULT[colorway][strength];
export const rootPadding = ({ isRound, size }) => isRound
    ? null
    : css `
        padding: 0 ${PADDING[size]}px;
      `;
export const rootSize = ({ isRound, size }) => {
    const badgeSize = SIZE[size];
    return css `
    ${isRound
        ? css `
          width: ${badgeSize}px;
        `
        : null};
    height: ${badgeSize}px;
  `;
};
export const valueColor = ({ alternateTheme, colorway, strength, }) => alternateTheme
    ? VALUE_COLOR.ALTERNATE[colorway][strength]
    : VALUE_COLOR.DEFAULT[colorway][strength];
export const valueTypeSpec = ({ size }) => CFMixins.typeSpec(TYPE_SPEC[size]);
